/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {setLanguage, useLang} from '../../../i18n/Metronici18n'

const languages = [
  {
    lang: 'ar',
    name: 'العربية',
    flag: toAbsoluteUrl('/media/flags/tunisia.svg'),
  },
  {
    lang: 'en',
    name: 'English',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  },
  {
    lang: 'fr',
    name: 'Français',
    flag: toAbsoluteUrl('/media/flags/france.svg'),
  },
  {
    lang: 'de',
    name: 'Deutsch',
    flag: toAbsoluteUrl('/media/flags/germany.svg'),
  },
  {
    lang: 'es',
    name: 'Español',
    flag: toAbsoluteUrl('/media/flags/spain.svg'),
  },
  {
    lang: 'ja',
    name: '日本語',
    flag: toAbsoluteUrl('/media/flags/japan.svg'),
  },
  {
    lang: 'zh',
    name: '中文',
    flag: toAbsoluteUrl('/media/flags/china.svg'),
  },
]

const LanguageSwitcher: FC = () => {
  const lang = useLang()
  const currentLanguage = languages.find((x) => x.lang === lang)
  
  return (
    <>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column w-200px w-lg-225px py-4'
        data-kt-menu='true'
      >
        <div className='menu-item px-3'>
          <div className='menu-content text-muted pb-2 px-3 fs-7 text-uppercase'>
            Select Language
          </div>
        </div>
        {languages.map((l) => (
          <div
            className='menu-item px-3'
            key={l.lang}
            onClick={() => {
              setLanguage(l.lang)
            }}
          >
            <a
              href='#'
              className={clsx('menu-link d-flex px-5', {active: l.lang === currentLanguage?.lang})}
            >
              <span className='symbol symbol-20px me-4'>
                <img className='rounded-1' src={l.flag} alt={l.name} />
              </span>
              <span>{l.name}</span>
            </a>
          </div>
        ))}
      </div>
    </>
  )
}

export {LanguageSwitcher, languages}

